export {
  FormLabel,
  type FormLabelProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/FormLabel';
